import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const routeName = (pathname) => {
  const map = {
    "/": "login",
    "/activate": "activate-account",
    "/register": "register",
    "/password": "password-parent",
    "/reset": "reset-password",
    "/otplogin": "otp-login",
    "/emailcodeverification": "email-code-verification",
    "/phoneverification": "phone-verification",
    "/resend": "resend-activation",
    "/emailverification": "email-verification",
    "/google": "finish-google",
    "/facebook": "finish-facebook",
    "/apple": "finish-apple",
    "/dealer": "dealer",
    "/logout": "logout",
    "/noemail": "apple-share-email",
    "/unknownerror": "unknown-error",
  };
  return map[pathname] || "login";
};

const canonical = () => {
  const el = document.querySelector('link[rel="canonical"]');
  return (el && el.href) || window.location.origin + window.location.pathname;
};

export default function PageRouteTracker() {
  const { pathname } = useLocation();
  const first = useRef(true);

  useEffect(() => {
    window.__analytics_queue__ = window.__analytics_queue__ || [];

    const event = first.current ? "aa-pageload" : "aa-view-change";

    const contentSectionMap = {
      "/": "Sign In Landing Page",
      "/otplogin": "Sign in Verify by Text",
      "/phoneverification": "Sign in Verify by Text",
      "/emailcodeverification": "sign in Verify by Email"
    };

    const data = {
      view_name: routeName(pathname),
      canonicalURL: canonical(),
      app: 'tcom sign in',
      content_section: contentSectionMap[pathname] || "Sign In",
      ...(first.current && { user_entry_source: "Toyota" }),
      user_logged_status: 'Logged Out',
      pageTitle: document.title,
      environment: document.documentElement.getAttribute("data-env-name") || "pre-prod",
      language: document.documentElement.lang || "en",
    };

    window.__analytics_queue__.push({ event, data });
    first.current = false;
  }, [pathname]);

  return null;
}